import http from "@/shared/services/http";

export const createContact = (data: any) => http.post(`v1/contacts/create`, data);
export const singleContact = (id: any) => http.get(`v1/contacts/${id}`);
export const editContact = (id: any, data: any) => http.put(`v1/contacts/${id}`, data);
export const deleteContact = (id: any) => http.delete(`v1/contacts/${id}`);
export const listContacts = (params: any) => http.get(`v1/contacts/list`, { params });